import { declareVueComponent } from '/vodalys/vvuejs'

import VrunFormCheckboxCellComponent from './VrunFormCheckboxCellComponent.vue'

declareVueComponent('vrun-form-checkbox-cell-component', VrunFormCheckboxCellComponent)